(function () {
  if (window.__smartgrCardVideo) return;
  window.__smartgrCardVideo = true;

  var conn = navigator.connection || {};
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || conn.saveData) return;

  var CARD = '.product-item';
  var VIDEO = '[data-card-video]';
  var HOVER_DELAY = 120;      // ms: evita carregar vídeo quando o mouse só "passa" pelo card
  var MIN_VISIBLE = 0.6;      // mobile: % do card visível para tocar

  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function play(card) {
    var v = card.querySelector(VIDEO);
    if (!v) return;

    if (!v._cvBound) {
      v._cvBound = true;
      v.addEventListener('playing', function () { card.classList.add('is-video-playing'); });
    }
    if (!v.getAttribute('src')) v.src = v.dataset.src;

    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* autoplay bloqueado: mantém a imagem */ });
  }

  function stop(card) {
    var v = card.querySelector(VIDEO);
    card.classList.remove('is-video-playing');
    if (v && !v.paused) v.pause();
  }

  /* ---------- DESKTOP: hover ---------- */
  if (canHover) {
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest && e.target.closest(CARD);
      if (!card || !card.querySelector(VIDEO)) return;
      if (card.contains(e.relatedTarget)) return;
      clearTimeout(card._cvTimer);
      card._cvTimer = setTimeout(function () { play(card); }, HOVER_DELAY);
    });

    document.addEventListener('mouseout', function (e) {
      var card = e.target.closest && e.target.closest(CARD);
      if (!card || !card.querySelector(VIDEO)) return;
      if (card.contains(e.relatedTarget)) return;
      clearTimeout(card._cvTimer);
      stop(card);
    });
    return;
  }

  /* ---------- MOBILE: um vídeo por vez, o card mais visível ---------- */
  if (!('IntersectionObserver' in window)) return;

  var ratios = new Map();
  var current = null;

  function pick() {
    ratios.forEach(function (r, card) {
      if (!card.isConnected) ratios.delete(card);
    });

    // histerese: mantém o atual enquanto ele ainda estiver bem visível (evita "pisca-pisca")
    if (current && (ratios.get(current) || 0) >= MIN_VISIBLE) return;

    var best = null, bestRatio = 0;
    ratios.forEach(function (r, card) {
      if (r > bestRatio) { bestRatio = r; best = card; }
    });

    if (current && current !== best) stop(current);
    current = bestRatio >= MIN_VISIBLE ? best : null;
    if (current) play(current);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var card = entry.target;
      if (entry.isIntersecting) {
        ratios.set(card, entry.intersectionRatio);
      } else {
        ratios.delete(card);
        stop(card);
        if (current === card) current = null;
      }
    });
    pick();
  }, { threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] });

  function scan() {
    document.querySelectorAll(VIDEO).forEach(function (v) {
      var card = v.closest(CARD);
      if (card && !card._cvObserved) {
        card._cvObserved = true;
        io.observe(card);
      }
    });
  }

  var raf;
  new MutationObserver(function () {
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(scan);
  }).observe(document.body, { childList: true, subtree: true });

  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('visibilitychange', function () {
    if (document.hidden && current) { stop(current); current = null; }
    else pick();
  });

  scan();
})();